import { renderMarkdown, replaceHashtags, replaceMentions, autoLinkUrls } from './markdown'

export function renderContent(content: string): string {
  return replaceMentions(replaceHashtags(autoLinkUrls(renderMarkdown(content))))
}
